import type { FC } from 'react';
import { useSetAtom } from 'jotai';
import { installmentCollapsed } from '@packages/modules/src/atoms';
import { Layout3 } from '../Layout3/Layout3.client';

export type InstallmentCalulatorInCardProps = {
  /**
   * the single installment value from the calculation result as Integer (e.g. 1337)
   */
  singleInstallment: number;
  /**
   * the currency string from the calculation result
   */
  currency: string;
  /**
   * the calulator ID auf the card element
   */
  calculatorID: string;
};

/**
 * Promotion component Layout 1
 *
 * component to promote the installment calculator in layout version 1
 *
 * */
export const InstallmentCalulatorInCard: FC<InstallmentCalulatorInCardProps> = ({
  singleInstallment,
  currency,
  calculatorID,
}) => {
  const setCollapsed = useSetAtom(installmentCollapsed);

  const handleAction = () => {
    setCollapsed(false);
    document.getElementById(calculatorID)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  return (
    <Layout3
      singleInstallment={singleInstallment}
      currency={currency}
      openInstallmentCalulatorHandler={() => handleAction()}
    />
  );
};
